module.exports = __webpack_public_path__ + "static/media/sp3.077e0603.jpg";